<template>
  <li class="bookings">
    <MobileMenuItem
      :item="config.item"
      :panel="true"
      :utag-event-info="{
        event_act: 'manage my bookings',
        event_lbl: 'dropdown',
      }"
    >
      <template #panel>
        <div class="my-bookings--container">
          <h3 class="title-subpanel t-fb-label">{{ config.a11y.my_bookings }}</h3>
          <!-- RENDERIZO POR JS COGIENDO EL CONTENIDO DE #info-user-level-template -->
        </div>
        <PrivateArea :config="privateAreaConfig" />
      </template>
    </MobileMenuItem>
  </li>
</template>

<script>
import MobileMenuItem from '../MobileMenuItem/MobileMenuItem'
import PrivateArea from '../PrivateArea/PrivateArea'

const componentName = 'MobileMenuBookings'

export default {
  name: componentName,
  components: {
    MobileMenuItem,
    PrivateArea,
  },
  props: {
    config: Object,
    privateAreaConfig: Object,
  },
  data() {
    return {
      user: { logged_in: false },
    }
  },
  mounted() {
    if (IB.browsing_sessions.getData()) {
      this.user = IB.browsing_sessions.getData().redis_values
    }
  },
}
</script>
